module.exports = __webpack_public_path__ + "static/media/api-integration.43a48f3e.png";